import React, { useState } from "react";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { ViewImage } from "..";

type UserFeedImagesProps = {
  feedImages: string[] | undefined;
  setShowAllImages: React.Dispatch<React.SetStateAction<number | null>>;
  showAllImages: number | null;
  editCotent: boolean;
  isLocked?: boolean | (() => void);
  toggle?: boolean | (() => void);
};

const UserFeedImages: React.FC<UserFeedImagesProps> = ({
  feedImages,
  setShowAllImages,
  showAllImages,
  editCotent,
  isLocked,
  toggle,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClick = (index: number) => {
    setShowAllImages(index);
    setCurrentIndex(index);
    if (typeof toggle === "function") {
      toggle();
    }
  };

  const totalImages = feedImages?.length || 0;
  // console.log(totalImages);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < totalImages - 1 ? prevIndex + 1 : prevIndex
    );
  };
  const handleClickClose = () => {
    setShowAllImages(null);
    if (typeof toggle === "function") {
      toggle();
    }
  };
  return (
    <>
      {!editCotent && (
        <div className="flex w-full bg-white" key={2 * 2}>
          {feedImages && feedImages?.length > 4 ? (
            <div className="grid grid-rows-3 grid-flow-col grid-cols-3 w-full mb-8 h-[250px] lg:h-[400px]">
              {feedImages?.map(
                (image, i) =>
                  i === 0 && (
                    <div
                      className={`row-span-full col-span-2 border relative overflow-hidden cursor-pointer ${
                        totalImages === i ? "selected" : ""
                      }`}
                      onClick={() => handleClick(i)}
                      key={i + 1}
                    >
                      <img
                        src={ipfsGatewayImage(image)}
                        loading="lazy"
                        alt=""
                        className="w-full object-cover h-full object-center"
                      />
                    </div>
                  )
              )}
              {feedImages &&
                feedImages?.slice(1, 4).map((image, i) => (
                  <div
                    className="h-full relative overflow-hidden"
                    key={i + 2}
                    onClick={() => handleClick(i + 1)}
                  >
                    <div className="border w-full h-full relative cursor-pointer">
                      <img
                        src={ipfsGatewayImage(image)}
                        loading="lazy"
                        alt=""
                        className="w-full object-cover h-full object-center"
                      />
                    </div>
                    {i === feedImages?.slice(1, 4).length - 1 && (
                      <div
                        className="w-full h-full text-white text-center bg-[rgba(0,0,0,0.7)] top-0 right-0 absolute font-Poppins text-2xl items-center flex justify-center cursor-pointer"
                        key={i + 3}
                        onClick={() => setShowAllImages(4)}
                      >
                        <p>+ {feedImages?.length - 4}</p>
                      </div>
                    )}
                  </div>
                ))}
            </div>
          ) : feedImages && feedImages?.length > 3 ? (
            <div className="flex flex-col w-full mb-8 lg:h-[350px] h-[250px]">
              {feedImages?.map(
                (imageUrl, index) =>
                  index === 0 && (
                    <div className="flex w-full" key={index + 8}>
                      <div
                        className={`w-full border relative lg:h-[250px] h-auto overflow-hidden cursor-pointer ${
                          totalImages === index ? "selected" : ""
                        }`}
                        onClick={() => handleClick(index)}
                      >
                        <img
                          src={ipfsGatewayImage(imageUrl)}
                          alt=""
                          loading="lazy"
                          className="w-full object-cover h-full object-center"
                        />
                      </div>
                    </div>
                  )
              )}
              <div className="grid grid-flow-row overflow-hidden col-span-3 grid-cols-3 w-full">
                {feedImages?.map(
                  (imageUrl, index) =>
                    index !== 0 && (
                      <div key={index + 101} className="w-full">
                        <div className="relative w-full lg:h-[90%] lg:max-h-[90%] h-auto overflow-hidden">
                          <div
                            className="border-2 w-full h-full cursor-pointer"
                            onClick={() => handleClick(index)}
                          >
                            <img
                              src={ipfsGatewayImage(imageUrl)}
                              alt=""
                              loading="lazy"
                              className="w-full object-cover h-full object-center"
                            />
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          ) : (
            <div className="flex w-full">
              {feedImages?.length === 1
                ? feedImages.map((imageUrl, index) => (
                    <div
                      className="flex w-full max-h-[350px] mb-8"
                      key={index * 8}
                    >
                      <div
                        className="w-full relative cursor-pointer h-auto overflow-hidden"
                        onClick={() => handleClick(index)}
                      >
                        <img
                          src={ipfsGatewayImage(imageUrl)}
                          alt=""
                          loading="lazy"
                          className="w-full object-cover h-full object-center"
                        />
                      </div>
                    </div>
                  ))
                : feedImages?.length === 2
                ? feedImages?.map((image, i) => (
                    <div className="flex w-full bg-white mb-8" key={i + 22}>
                      <div
                        className="h-[400px] cursor-pointer flex justify-between gap-1 w-full overflow-hidden border-2 relative"
                        onClick={() => handleClick(i)}
                      >
                        <img
                          src={ipfsGatewayImage(image)}
                          loading="lazy"
                          alt=""
                          className="w-full object-cover object-center"
                        />
                      </div>
                    </div>
                  ))
                : feedImages?.length === 3 && (
                    <div className="flex w-full mb-8">
                      {feedImages.map(
                        (aImage, i) =>
                          i === 0 && (
                            <div
                              className="flex w-full max-h-[400px]"
                              key={i + 21}
                            >
                              <div
                                className={`w-full border relative lg:h-[400px] h-[250px] overflow-hidden cursor-pointer ${
                                  totalImages === i ? "selected" : ""
                                }`}
                                onClick={() => handleClick(i)}
                              >
                                <img
                                  src={ipfsGatewayImage(aImage)}
                                  alt=""
                                  loading="lazy"
                                  className="w-full object-cover h-full object-center"
                                />
                              </div>
                            </div>
                          )
                      )}
                      <div className="grid grid-rows-2 lg:h-[400px] h-[250px] w-full overflow-hidden">
                        {feedImages?.map(
                          (feedImage, i) =>
                            i !== 0 && (
                              <div
                                className="flex w-full overflow-hidden relative h-auto"
                                key={i * 2}
                              >
                                <div
                                  className="w-full flex-1 border flex cursor-pointer"
                                  onClick={() => handleClick(i)}
                                >
                                  <img
                                    src={ipfsGatewayImage(feedImage)}
                                    loading="lazy"
                                    alt=""
                                    className="w-full object-cover h-full object-center "
                                  />
                                </div>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  )}
            </div>
          )}
          {feedImages &&
            isLocked &&
            showAllImages !== null &&
            totalImages > 0 && (
              <ViewImage
                feedImages={feedImages}
                currentIndex={currentIndex}
                totalImages={totalImages}
                handleNext={handleNext}
                handlePrev={handlePrev}
                handleClick={handleClickClose}
              />
            )}
        </div>
      )}
    </>
  );
};

export default UserFeedImages;
